// Import all MBTI type images
import ENFJ from './mbti-images/ENFJ.jpg';
import ENFP from './mbti-images/ENFP.jpg';
import ENTJ from './mbti-images/ENTJ.jpg';
import ENTP from './mbti-images/ENTP.jpg';
import ESFJ from './mbti-images/ESFJ.jpg';
import ESFP from './mbti-images/ESFP.jpg';
import ESTJ from './mbti-images/ESTJ.jpg';
import ESTP from './mbti-images/ESTP.jpg';
import INFJ from './mbti-images/INFJ.jpg';
import INFP from './mbti-images/INFP.jpg';
import INTJ from './mbti-images/INTJ.jpg';
import INTP from './mbti-images/INTP.jpg';
import ISFJ from './mbti-images/ISFJ.jpg';
import ISFP from './mbti-images/ISFP.jpg';
import ISTJ from './mbti-images/ISTJ.jpg';
import ISTP from './mbti-images/ISTP.jpg';

export default {
  ENFJ, ENFP, ENTJ, ENTP,
  ESFJ, ESFP, ESTJ, ESTP,
  INFJ, INFP, INTJ, INTP,
  ISFJ, ISFP, ISTJ, ISTP
}; 
